import { FC } from "react";
import { Box, Button, Text, VStack, Heading, useToast } from "@chakra-ui/react";
import { ProductConfig } from "~/DiagnosticsApp/constants";
import { useDiagnosticCheckoutSessionsCreateMutation } from "~/store/api";

interface ProductCheckoutCardProps {
  product: ProductConfig;
  tagline?: string;
  description: string;
  buttonText?: string;
}

export const ProductCheckoutCard: FC<ProductCheckoutCardProps> = ({
  product,
  tagline,
  description,
  buttonText = "Buy now",
}) => {
  const Logo = product.logo;
  const color = product.color;
  const toast = useToast();
  const [createCheckoutSession, { isLoading }] = useDiagnosticCheckoutSessionsCreateMutation();

  const handleCheckout = async () => {
    try {
      const result = await createCheckoutSession({ product_slug: product.slug }).unwrap();
      
      // Redirect to Stripe checkout
      window.location.href = result.stripe_checkout_url;
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to create checkout session. Please try again.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Box
      bg="white"
      borderRadius="12px"
      p={6}
      boxShadow="0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)"
      w="full"
      maxW="369px"
      minH="443px"
      display="flex"
      flexDirection="column"
    >
      <VStack align="stretch" spacing={0} flex={1}>
        <Box flex={1} display="flex" flexDirection="column">
          <Box mb={4}>
            <Logo boxSize="80px" />
          </Box>
          <Text
            fontSize="12px"
            fontWeight="500"
            textTransform="uppercase"
            color={color}
            letterSpacing="0.05em"
            mb={2}
          >
            {tagline}
          </Text>
          <Heading
            as="h3"
            fontSize="28px"
            fontWeight="600"
            lineHeight="36px"
            color="#111827"
            mb={3}
          >
            {product.name}
          </Heading>
          <Text
            fontSize="16px"
            lineHeight="24px"
            color="#374151"
            mb={6}
          >
            {description}
          </Text>
          {/* <Box flex={1} /> */}
          {/* {expandedSection && ( */}
          {/*   <Box borderTop="1px solid" borderColor="#E5E7EB" pt={4} mb={6}> */}
          {/*     <Flex */}
          {/*       align="center" */}
          {/*       justify="space-between" */}
          {/*       cursor="pointer" */}
          {/*     > */}
          {/*       <Text */}
          {/*         fontSize="16px" */}
          {/*         fontWeight="500" */}
          {/*         color="#111827" */}
          {/*       > */}
          {/*         {expandedSection.title} */}
          {/*       </Text> */}
          {/*       <Plus boxSize={5} color="#6B7280" /> */}
          {/*     </Flex> */}
          {/*   </Box> */}
          {/* )} */}
        </Box>
        <Button
          width="full"
          bg="#254642"
          color="white"
          fontSize="16px"
          fontWeight="500"
          h="48px"
          borderRadius="8px"
          _hover={{ bg: "#1a312e" }}
          onClick={handleCheckout}
          isLoading={isLoading}
          loadingText="Creating checkout..."
        >
          {buttonText} · {product.price}
        </Button>
      </VStack>
    </Box>

  );
}

